<template>
  <el-dialog
    :visible.sync="dialog"
    width="950px"
    center
    :before-close="handleClose"
    custom-class="my-dialog"
  >
    <div class="pano-header">
      <span class="title">音频素材库</span>
     
      <div class="select">
        <el-input placeholder="请输入内容" v-model="searchTxt" class="input-with-select">
          <el-button slot="append" icon="el-icon-search"></el-button>
        </el-input>
      </div>
      <div class="upload-block">
        <upload :type="type" :func="uploadPic"></upload>
      </div>
    </div>
    <div class="pano-modal-body">
      <div class="title-line">
        <div class="title-line-left">
     
        </div>
      </div>
      <div class="list">
        <div class="list-li" v-for="(item,i) in arr" :key="i" @click="choose(item.id)">
          <div class="checkbox-block">
            <div :class="{'checkbox':true,'active':item.check}">
              <i class="el-icon-check"></i>
            </div>
          </div>
          <div class="middle">
            <div class="img-block">
              <img :src="item.thumbnailUrl" />
            </div>
            <div class="li-title">{{item.fileName}}</div>
          </div>

          <div class="date">{{item.createTime | dateFormat('YY-mm-dd HH:MM')}}</div>
        </div>
      </div>
      <div class="page-block">
        <el-pagination
          @current-change="handleCurrentChange"
          :page-size="8"
          :current-page="page.currentPage"
          layout="total, prev, pager, next, jumper"
          :total="page.total"
        ></el-pagination>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submit">确 定</el-button>
    </span>
  </el-dialog>
</template>
<style>
.my-dialog{
  z-index:10000;
  color: black;
}
.my-dialog.el-dialog--center .el-dialog__body {
  padding: 0 0 10px 0;
}

/* .my-dialog .el-dialog__header {
  padding: 0;
} */

.my-dialog .el-dialog__headerbtn {
  top: 7px;
  right: 7px;
  z-index: 10;
}
.el-pager .number{
 color: black;
}
</style>
<style scoped>
.pano-header {
  height: 60px;
  display: flex;
  align-items: center;
  position: relative;
  padding: 0 20px;
  font-size: 20px;
  border-bottom: 1px solid #e9e9e9;
}

.title {
  margin-right: 20px;
  font-size: 16px;
  font-weight: 700;
  color: black;
}

.select {
  flex: 1 auto;
}

.input-with-select {
  width: 200px;
}

.upload-block {
  font-size: 14px;
}

.pano-model-body {
  position: relative;
  flex: 1 auto;
}

.title-line {
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 30px;
  background-color: #f3f3f3;
  border-bottom: 1px solid #e9e9e9;
}

.title-line-left {
  display: flex;
  align-items: center;
}
.all-word {
  color: black;
}

.checkbox-block {
  margin-right: 10px;
}

.checkbox {
  height: 16px;
  width: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  border: 1px solid #d8d8d8;
  cursor: pointer;
  color: white!important;
}

.checkbox.active {
  background-color: #427afb;
  border-color: #427afb;
}

.list {
  height: 435px;
}

.list-li {
  height: 50px;
  width: 100%;
  display: flex;
  align-items: center;
  padding: 0 40px;
  border-bottom: 1px solid #e9e9e9;
}

.middle {
  display: flex;
  flex: 1 auto;
  align-items: center;
}

.img-block {
  width: 30px;
  height: 30px;
  background-color: #ddd;
  cursor: pointer;
}

.img-block img {
  width: 100%;
  height: 100%;
}

.li-title {
  max-width: 500px;

  margin-left: 10px;
  line-height: 30px;
  font-size: 12px;
  white-space: nowrap;
  -o-text-overflow: ellipsis;
  text-overflow: ellipsis;
  overflow: hidden;
  cursor: pointer;
  color: black;
}

.date {
  font-size: 12px;
  color: #9b9b9b;
}

.page-block {
  display: flex;
  justify-content: center;
}
</style>
<script>
import https from '../https.js'
import Upload from '../components/upload.vue'
export default {
  name: '',
  props: {
    type: String,
    closeFunc: Function,
    submitFunc: Function
  },
  components: {
    Upload: Upload
  },

  data() {
    return {
      dialog: true,
      searchTxt: '',
      allcheck: false,
      page: {
        currentPage: 1,
        total: 0
      },
      chooseArr: [],
      arr: [
        // {
        //   id: "44901c67-81c4-4f30-8fea-c1d0dfc1927b",
        //   fileName: "weixin_code.png",
        //   filePath: "/Attached/2020/6/17/weixin_code.png",
        //   fileFormat: ".png",
        //   hashValue: "2020617135921",
        //   fileSize: 11917,
        //   type: null,
        //   status: 1,
        //   createTime: "2020-06-17T13:59:21.487",
        //   thumbnailUrl: null
        // }
      ]
    }
  },
  created() {},
  mounted() {
    this.init()
  },
  methods: {
    init() {
      https
        .fetchPost('/api/PhysicalFile/Get', {
          type: this.type,
          pageIndex: this.page.currentPage,
          pageSize: 8
        })
        .then(res => {
          console.log(res.data)
          this.page.total = res.data.count

          for (let i = 0; i < res.data.result.length; i++) {
            res.data.result[i].check = false
          }
          this.arr = res.data.result
        })
    },
    handleCurrentChange(val) {
      this.allcheck = false
      this.chooseArr = []
      this.page.currentPage = val
      this.init()
    },
  
    choose(id) {
      this.chooseArr = []
      for (let i = 0; i < this.arr.length; i++) {
          this.arr[i].check = false
        if (this.arr[i].id === id) {

          const isCheck = this.arr[i].check || false
          if (isCheck) {
            this.arr[i].check = false
          } else {
            console.log(isCheck)
            this.arr[i].check = true
            console.log(this.arr)
            this.chooseArr.push(this.arr[i])
          }
        } else {
          if (this.arr[i].check) {
            this.chooseArr.push(this.arr[i])
          }
        }
      }
      if (this.chooseArr.length === 8) {
        this.allcheck = true
      } else {
        this.allcheck = false
      }
    },
    handleClose(done) {
      this.closeFunc()
    },
    uploadPic(data) {
      console.log(data)
      this.init()
    },
    submit() {
      this.submitFunc(this.chooseArr)
      this.closeFunc()
    }
  }
}
</script>
